import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcAlert32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m16.031 2.001c.532 0 .969.47.969 1v3.063c4.281.469 7 3.969 7 9.187v3.75c0 2.625.656 3.938 2.531 5.157.282.187.469.5.469.843 0 .594-.468 1-1 1h-6c0 2.22-1.781 4-4 4s-4-1.78-4-4h-6c-.531 0-1-.406-1-1 0-.343.188-.656.469-.843 1.875-1.22 2.531-2.532 2.531-5.158v-3.75c0-5.218 2.719-8.718 7-9.187v-3.063c0-.562.438-1.03 1-1zm1.969 24h-4c0 1.094.906 2 2 2s2-.906 2-2zm-2-18c-3.75 0-6 2.72-6 7.25v3.75c0 1.782-.375 3.532-1.375 5h14.75c-1-1.468-1.375-3.218-1.375-5v-3.75c0-4.5-2.25-7.25-6-7.25z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcAlert32;
